import React from "react";
import styles from "./AnimAttention.module.css";

export type AnimAttentionProps = {
  className?: string;
  children: React.ReactNode;
  rectClassName?: string;
  alert?: boolean;
};

const AnimAttention: React.FC<AnimAttentionProps> = ({ className, children, rectClassName, alert }) => {
  return (
    <section className={`${styles.buttons} ${className ?? ""}`}>
      <div className={styles.container}>
        <div className={`${styles.btn} ${styles.btn1}`}>
          <svg
            className={styles.svg}
            viewBox="0 0 160 45"
            preserveAspectRatio="none"
            aria-hidden
          >
            <rect
              className={`${styles.rect} ${rectClassName ? styles[rectClassName] : ""} ${alert ? styles.alert : ""}`}
              x="1"
              y="1"
              width="158"
              height="43"
              rx="7"
              ry="7"
            />
          </svg>

          <div className={styles.content}>
            {children}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnimAttention;
